import { createAction, handleActions } from 'redux-actions';

// ACTION CREATORS
export const getDrafts = createAction('GET_DRAFTS');
export const setDrafts = createAction('SET_DRAFTS');
export const saveDraft = createAction('SAVE_DRAFT');
export const publishDraft = createAction('PUBLISH_DRAFT');
export const rejectDraft = createAction('REJECT_DRAFT');
export const withdrawDraft = createAction('WITHDRAW_DRAFT');

// REDUCER
export const reducer = handleActions(
  new Map([
    [
      setDrafts,
      (state, action) => action.payload
    ]
  ]),
  []
);
